"use strict";
'use es6'; // These are used ONLY to attach to nodes for acceptance test purposes

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATE_A_BUNDLE = exports.CMS_STARTER_MC_BUNDLE = exports.CMS_STARTER_BUNDLE = exports.GROWTH_SUITE_ENTERPRISE_MC = exports.GROWTH_SUITE_PROFESSIONAL_MC = exports.GROWTH_SUITE_STARTER_MC = exports.GROWTH_SUITE_ENTERPRISE = exports.GROWTH_SUITE_PROFESSIONAL = exports.GROWTH_SUITE_STARTER = void 0;
var GROWTH_SUITE_STARTER = 'growth-suite-starter';
exports.GROWTH_SUITE_STARTER = GROWTH_SUITE_STARTER;
var GROWTH_SUITE_PROFESSIONAL = 'growth-suite-professional';
exports.GROWTH_SUITE_PROFESSIONAL = GROWTH_SUITE_PROFESSIONAL;
var GROWTH_SUITE_ENTERPRISE = 'growth-suite-enterprise';
exports.GROWTH_SUITE_ENTERPRISE = GROWTH_SUITE_ENTERPRISE;
var GROWTH_SUITE_STARTER_MC = 'growth-suite-starter-mc';
exports.GROWTH_SUITE_STARTER_MC = GROWTH_SUITE_STARTER_MC;
var GROWTH_SUITE_PROFESSIONAL_MC = 'growth-suite-professional-mc';
exports.GROWTH_SUITE_PROFESSIONAL_MC = GROWTH_SUITE_PROFESSIONAL_MC;
var GROWTH_SUITE_ENTERPRISE_MC = 'growth-suite-enterprise-mc';
exports.GROWTH_SUITE_ENTERPRISE_MC = GROWTH_SUITE_ENTERPRISE_MC;
var CMS_STARTER_BUNDLE = 'cms-starter-bundle';
exports.CMS_STARTER_BUNDLE = CMS_STARTER_BUNDLE;
var CMS_STARTER_MC_BUNDLE = 'cms-starter-mc-bundle';
exports.CMS_STARTER_MC_BUNDLE = CMS_STARTER_MC_BUNDLE;
var CREATE_A_BUNDLE = 'create-a-bundle';
exports.CREATE_A_BUNDLE = CREATE_A_BUNDLE;


//////////////////
// WEBPACK FOOTER
// ./js/constants/NonMerchandiseIdIdentifers.js
// module id = 284
// module chunks = 5 6